export const useParagraphTokenAnnotations = (
  annotations: RevisionAnnotations,
  paragraph: Paragraph,
  token: ParagraphToken
) => {
  var tokenIndex = paragraph.tokens.indexOf(token);

  return annotations.filter((annotation: RevisionAnnotation) => {
    annotation.tokenGlobalPositions.sort((a, b) => a - b);

    // IEW decided it should always come after
    // We also want any annotations where isEndLine is true and it is attached to this paragraph
    // And this is token is the last token in the paragraph
    // New condition: if the annotation has forceInline off then the annotation comment can't be considered long, it should bump to the next lne
    if (
      annotation.isEndLine == true &&
      annotation.paragraphId == paragraph.id &&
      (annotation.forceInline == true ||
        useIsAnnotationCommentLong(annotation) != true)
    ) {
      // this should make things backwards compatible with the old way of doing end line
      // I have now introduced the abiltiy to break a paragraph into token groups if there are unexpected line break we need to use to visually render multiple paragraphs

      return annotation.lastTokenGlobalPosition
        ? annotation.lastTokenGlobalPosition == token.globalPosition
        : tokenIndex ==
            useParagraphTokensWithoutLinebreaks(paragraph).length - 1;
    }

    return (
      annotation.tokenGlobalPositions[
        annotation.tokenGlobalPositions.length - 1
      ] == token.globalPosition
    );
  });
};
